import { render, staticRenderFns } from "./page-loadable.vue?vue&type=template&id=5d7e6e0c&"
import script from "./page-loadable.vue?vue&type=script&lang=js&"
export * from "./page-loadable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports